import { TypedDocumentNode, gql } from '@apollo/client';
import { faUserXmark } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { FRONTEND_ASSET_HOST } from '@sorare/core/src/constants/assets';
import { withFragments } from '@sorare/core/src/lib/gql';

import { RuleHelperFnReturnType } from '../types';
import { getNotNationalitiesRule_so5Rules } from './__generated__/getNotNationalitiesRule.graphql';

const getNotNationalitiesRule = withFragments(
  (
    rules: getNotNationalitiesRule_so5Rules,
    error: string
  ): RuleHelperFnReturnType => {
    const rule = rules.notNationalities;
    if (!rule?.length) {
      return null;
    }

    return {
      id: 'notNationalities',
      label: (
        <FormattedMessage
          id="Rules.notNationalities.label"
          defaultMessage="Restricted Nationalities"
        />
      ),
      description: (
        <Vertical as="span" gap={0}>
          {rule.map(({ slug, name }) => (
            <Horizontal key={slug} as="span">
              <img
                src={`${FRONTEND_ASSET_HOST}/flags/${slug}.svg`}
                alt=""
                width="16"
                height="16"
              />
              <span>{name}</span>
            </Horizontal>
          ))}
        </Vertical>
      ),
      icon: (
        <FontAwesomeIcon
          icon={faUserXmark}
          color="var(--c-red-600)"
          width="16"
          height="16"
        />
      ),
      error,
    };
  },
  {
    so5Rules: gql`
      fragment getNotNationalitiesRule_so5Rules on So5Rules {
        id
        notNationalities {
          slug
          name
        }
      }
    ` as TypedDocumentNode<getNotNationalitiesRule_so5Rules>,
  }
);

export default getNotNationalitiesRule;
